import React from 'react';

import { useDispatch, useSelector } from 'bundles/research/index/store/hooks';
import { hideOverlayFilters } from 'bundles/research/index/store/actions/ui';
import { setColumns } from 'bundles/research/index/store/actions/session';

import ColumnSelector from 'components/table_header/column_selector';
import { useCurrentColumnProps } from './hooks';

export default function PropertiesColumnSelector() {
  const currentColumnProps = useCurrentColumnProps();
  const defaultColumns = useSelector(state => state.ui.defaultColumns);
  const dispatch = useDispatch();

  return (
    <ColumnSelector
      {...currentColumnProps}
      defaultColumns={defaultColumns}
      onCancelColumns={() => dispatch(hideOverlayFilters())}
      onSetColumns={(columns) => {
        dispatch(setColumns(columns));
        dispatch(hideOverlayFilters());
      }}
    />
  );
}
